import { NgIf } from "@angular/common";
import { AfterViewInit, ChangeDetectorRef, Component, Input, ViewChild } from "@angular/core";

@Component({
  selector: "app-card-wrapper",
  templateUrl: "./card-wrapper.component.html",
  styleUrls: ["./card-wrapper.component.scss"],
  standalone: true,
  imports: [NgIf],
})
export class CardWrapperComponent implements AfterViewInit {
  @Input() title: string = ""; //titel van de card
  @Input() id: number = 0; //id van de card, nodig om naar te navigeren. Deze moet uniek zijn op een pagina.
  @Input() sidenavLabel: string | null = null; //titel van de rechtse navigatie. indien leeg, wordt de title genomen.
  @Input() hasIntro: boolean = false;
  @Input() validation?: boolean;
  @Input() checkedMsg?: string;
  @Input() uncheckedMsg?: string;
  @Input() titleSize: number = 5;

  @Input() centerTitle = false;

  @Input() foldable = false;
  @Input() folded = false;

  @Input() addXPaddingBody = true;
  @Input() addMarginBottomHeader = true;
  @Input() addPaddingFooter = true;

  @Input() fillFullHeightOfParent = false;
  @ViewChild("footerBlock")
  footerBlock: any;

  protected showFooter = true;
  constructor(private cdRef: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.showFooter =
      this.footerBlock.nativeElement && this.footerBlock.nativeElement.children.length > 0;
    this.cdRef.detectChanges();
  }
}
